<template lang="pug">
  #appFooter.appFooter.appFooter-sa
    .container.h-100
      .row.align-items-center.h-100.menu.no-gutters
        .col-12.py-1.text-center
          a(@click="routerPushHandler('Items')")
            .menu_icon
              i.icon-main_bottomMenu_home
            .menu_text
              span 主頁
</template>

<script>
import IconMsgWhiteUrl from '@/assets/images/icon/icon_msg_white.png';
import IconContactsWhiteUrl from '@/assets/images/icon/icon_contacts_white.png';
import IconQRCodeWhiteUrl from '@/assets/images/icon/icon_qrcode_white.png';
import IconItemsWhiteUrl from '@/assets/images/icon/icon_items_white.png';

export default {
  name: 'appSaFooter',
  data() {
    return {
      iconUrl: {
        IconMsgWhite: IconMsgWhiteUrl,
        IconContactsWhite: IconContactsWhiteUrl,
        IconQRCodeWhite: IconQRCodeWhiteUrl,
        IconItemsWhite: IconItemsWhiteUrl
      }
    };
  },
  methods: {
    routerPushHandler(target) {
      switch (target) {
        case 'Message':
          if (this.$route.name === 'sa-msg-manager-index') return;
          this.$router.push({ name: 'sa-msg-manager-index' });
          break;
        case 'Contacts':
          if (this.$route.name === 'sa-contacts-index') return;
          this.$router.push({ name: 'sa-contacts-index' });
          break;
        case 'QRCode':
          if (this.$route.name === 'sa-qr-code') return;
          this.$router.push({ name: 'sa-qr-code' });
          break;
        case 'Items':
          if (this.$route.name === 'sa-items-list-index') return;
          this.$router.push({ name: 'sa-items-list-index' });
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
  #menu {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 0.5rem solid #000;
    z-index: 2;
    padding: 0 2rem;
  }

  .icon-main_bottomMenu_chat:before {
    content: "\e906";
  }
  .icon-main_bottomMenu_home:before {
    content: "\e900";
  }

  .icon-main_bottomMenu_qrcode:before {
    content: "\e901";
  }

  .menu_icon {
    font-size: 1.5rem;
    background-size: cover;
    background-position: center;
    margin: 0 auto 0;
    position: relative;
  }

  @font-face {
    font-family: "icon";
    src: url("../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  .menu_icon.active::after {
    width: 0.5rem;
    height: 0.5rem;
    background-color: #ef4852;
    border-radius: 50%;
    top: 0;
    right: 0;
    -webkit-transform: translate(50%, 0);
    transform: translate(50%, 0);
    display: block;
    content: "";
    position: absolute;
  }

  .menu_text {
    font-size: 0.8rem;
    margin: -5px 0;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  a {
    display: inline-block;
    cursor: pointer;
    padding: 0.3rem 0;
  }

  .white-space-nowrap {
    white-space: nowrap;
  }
</style>
